<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <h2>{{ t('settings-journey-title') }}</h2>
                <div class="col-md-12 col-sm-12">
                    <board
                        :tree="tree"
                        :active="parentId"
                        @select="
                            (id) => {
                                $router.push('/settings/journey/' + id);
                            }
                        "
                    />
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12 col-sm-12">
                    <h3 v-if="parent.name">{{ t('settings-journey-stages') }} {{ parent.name }}</h3>
                    <div v-show="variants.length" class="variants-holder">
                        <button
                            :class="
                                'btn btn-small ' +
                                (activeVariant === variant
                                    ? 'btn-primary'
                                    : 'btn-outline-success')
                            "
                            v-for="(variant, id) in variants"
                            @click="activeVariant = variant"
                            :contenteditable="true"
                            :key="id"
                        >
                            <input
                                type="text"
                                :value="variant"
                                :size="variant.length + 1"
                                @keyup.enter="updateVariant($event, variant)"
                                @blur="updateVariant($event, variant)"
                                @keydown="
                                    (e) => {
                                        e.target.size =
                                            e.target.value.length + 1;
                                    }
                                "
                            />
                        </button>
                        <button
                            class="btn btn-outline-success"
                            @click="addVariant"
                        >
                            <span class="far-icon fa fa-plus"></span>
                        </button>
                    </div>
                    <div v-if="!journeyMap.children.length">
                        <div class="box my-4">
                            <p>
                                {{ parentId ? t('settings-journey-insert_first_substage') : t('settings-journey-insert_first_stage') }}
                            </p>
                        </div>
                    </div>
                    <journey-list
                        v-model="journeyMap"
                        @moved
                        :parentId="parentId"
                        :variant="activeVariant"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.page-content.settings-journey-id,
.page-content.settings-journey {
    max-width: 100%;
}
</style>
<style scoped lang="scss">
h3 {
    font-size: 20px;
    font-weight: 500;
    color: #777;
}
.variants-holder {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    input {
        display: inline-block;
        width: auto;
        background: transparent;
        border: none;
        cursor: pointer;
        font-weight: 500;
        min-width: 50px;
        color: inherit;
    }
}
.table.fields td {
    vertical-align: middle;
}
.actions {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 20px;
}
</style>
<script>
import keviApi from "../../keviApi";
import JourneyList from "./journeyList";
import Board from "./board";
export default {
    components: { JourneyList, Board },
    props: {
        user: Object,
    },
    data: function () {
        return {
            state: "loading",
            form: {
                root: null,
            },
            parent: {},
            activeVariant: null,
            allStages: [],
            variants: [],
            journeyMap: {
                children: [],
            },
            tree: [],
        };
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
        parentId() {
            return this.$route.params.id;
        },
    },
    async mounted() {
        document.getElementsByTagName("title")[0].innerText =
            "Kevi | " + this.t('settings-journey-title');
        await this.loadStages();
        await this.loadParent();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        async loadParent() {
            console.log(this.parentId);
            if (this.parentId) {
                const url = "client-stage/" + this.parentId;
                let options = keviApi.getOptions(url, "GET");
                const response = await this.$http(options);
                this.parent = response.data;
            } else {
                this.parent = {};
            }
        },
        async loadStages() {
            this.state = "loading";
            const url = this.parentId
                ? "client-stages/" + this.parentId
                : "client-stages";
            let options = keviApi.getOptions(url, "GET");
            const response = await this.$http(options);
            this.allStages = response.data;
            this.allStages.forEach((stage) => {
                if (!this.variants.includes(stage.variant)) {
                    this.variants.push(stage.variant);
                }
            });
            options = keviApi.getOptions("client-stages/tree", "GET");
            const responseTree = await this.$http(options);
            this.tree = responseTree.data;
            this.state = "loaded";
        },
        addVariant() {
            let c = 2;
            while (this.variants.includes(this.t('settings-journey-board_prefix') + " " + c)) {
                c++;
            }
            this.variants.push(this.t('settings-journey-board_prefix') + " " + c);
        },
        updateVariant(evt, variant) {
            if (evt.target.value && !this.variants.includes(evt.target.value)) {
                if (evt.target.value === variant) {
                    return;
                }
                this.$store.dispatch(
                    "notification/success",
                    this.t('settings-journey-board_renamed'),
                );
                this.variants = this.variants.map((v) => {
                    return v === variant ? evt.target.value : v;
                });
                this.allStages = this.allStages.map((stage) => {
                    if (stage.variant === variant) {
                        stage.variant = evt.target.value;

                        let options = keviApi.getOptions(
                            "client-stage",
                            "POST",
                            {
                                id: stage.id,
                                variant: event.target.value,
                            },
                        );
                        this.$http(options);
                    }
                    return stage;
                });
                this.journeyMap.children = this.journeyMap.children.map(
                    (stage) => {
                        if (stage.variant === variant) {
                            stage.variant = evt.target.value;
                        }
                        return stage;
                    },
                );
                this.activeVariant = evt.target.value;
            } else {
                evt.target.value = variant;
            }
        },
    },
    watch: {
        "journeyMap.children": function () {
            this.loadStages();
        },
        parentId: async function () {
            this.activeVariant = null;
            this.variants = [];
            await this.loadParent();
            await this.loadStages();
        },
        variants: function () {
            if (!this.activeVariant && this.variants.length) {
                this.activeVariant = this.variants[0];
            }
        },
        activeVariant: function () {
            this.journeyMap.children = this.allStages.filter((stage) => {
                return stage.variant === this.activeVariant;
            });
        },
    },
};
</script>
